// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__cvs3g","label":"styles_label__WRyT0","icon":"styles_icon__Kx5qU"};